import React from 'react';
import Observer from '@researchgate/react-intersection-observer';

class IntersectionObserver extends React.Component {
    state = {
        isVisible: false
    };

    handleChange = (event, unobserve) => {
        if (event.isIntersecting) {
            unobserve();
        }
        this.setState({
            isVisible: event.isIntersecting
        });
    };

    render() {
        const { children, ...other } = this.props;
        const { isVisible } = this.state;
        return (
            <Observer onChange={this.handleChange} {...other}>
                <div>{children(isVisible)}</div>
            </Observer>
        );
    }
}

export default IntersectionObserver;
